import LoginForm from "../../components/OnBoard/LoginForm";
import { useSelector } from "react-redux";
import RightContent1 from "../../components/OnBoard/login_right";
import styles from "./Login.module.css";
import { resetTimer } from "../../Utils/helper";
import usePageTitle from "../../Hooks/useDocTitle";
import { MAINTENANCE_STATUS } from "../../Utils/constant";
import { useEffect, useState } from "react";
import API from"../../ApiConfig";
import cogoToast from "cogo-toast-react-17-fix";
import { useLocation, useNavigate } from "react-router-dom";
const Login = () => {
  usePageTitle('Login')


  const [maintenanceAlert, setMaintenanceAlert]=useState(false)
  const [maintenanceText, setMaintenanceText]=useState("")
  const [loginDisable, setLoginDisable]=useState(false)
  const maintenanceStatus=()=>{
      API.get(MAINTENANCE_STATUS)
      .then(res=>{
        if(res.data.status==200){
  
          if(res.data.data.is_active){
            setMaintenanceAlert(true)
            setMaintenanceText(res.data.data.message)
            if(res.data.data.login_disabled){
              setLoginDisable(true)
            }
          }
          else{
            setMaintenanceAlert(false)
          }
        }  
      })
      .catch(err=>{
        cogoToast.error(err.response.data.message)        
      })
    }
    useEffect(()=>{
      maintenanceStatus()
    
    },[])
      const location = useLocation();
    
      // Save hash to localStorage when landing on /login#12333
      useEffect(() => {
        const hashToken = location.hash.substring(1); // "12333"
        if (hashToken) {
          localStorage.setItem("doc_token", hashToken);
        }
      }, [])
  const User = useSelector(state => state.User)
  if (User.user_name) {
    window.location.href = "/dashboard"
  }
  else {
    resetTimer()
    return (
      <>
      {maintenanceAlert&&
      <div className="bg-yellow-100 border border-yellow-300 text-yellow-800 px-4 py-3 rounded relative text-center" style={{width:"100%"}}>
    🚧 {maintenanceText}.
    {/* The system is under scheduled maintenance. Some features may be unavailable.   */}
    <span className="font-semibold"> We’ll be back soon!</span>
  </div>}
      <div className={styles.login}>
        {/* {maintenanceAlert&& */}
  {/* } */}
        <div className={styles.leftContentParent}>
          <div className={styles.leftContent} style={{justifyContent:"space-evenly"}}>
            <LoginForm disableLogin={loginDisable} />
          </div>
          <div className={styles.footer}>
            <div className={styles.container}>
              <div className={styles.copyright}>
              Copyright 2026 AuthBridge, All Rights Reserved.
              </div>
              <div className={styles.socialLinks}>
                <img className={styles.facebookIcon} alt="" src="/facebook.svg" />
                <img className={styles.twitterIcon} alt="" src="/twitter.svg" />
                <img className={styles.githubIcon} alt="" src="/github-1.svg" />
                <img
                  className={styles.fontawesomedribbbleIcon}
                  alt=""
                  src="/fontawesomedribbble.svg"
                />
              </div>
            </div>
          </div>
        </div>
        <RightContent1 />
      </div>
      </>
    );
  }
};

export default Login;
